import {writable} from 'svelte/store';

const createToasts = () => {
    const { subscribe, set, update} = writable([]);

    const expireToasts = setInterval(() => {
        update(
            n => n.filter(
                toast => Date.now()-toast.time <= 4000
            )
        );
    }, 100);

    return {
        subscribe,
        pushToast: (toast, type="black") => update(n => [{
            text:toast, 
            time: Date.now(),
            color: type
        }, ...n]),
        popToast: () => update(n => {
            let copy = [...n];
            copy.pop();
            return copy
        }),
        reset: () => set([])
    };
}

const createInvoices = () => {
    const { subscribe, set, update, derived } = writable([]);

    return {
        subscribe,
        pushInvoice: (iv, id) => update(n => [{invoice: iv, id: id}, ...n]),
        deleteInvoice: id => update(n => n.filter(iv => iv.id != id)),
        setInvoice: (iv, id) => update(n => n.map(
            x => x.id == id ? {invoice: iv, id: id} : x
        )),
        getInvoice: id => subscribe(ivs => ivs.filter(iv => iv.id == id)),
        reset: () => set([])
    };
}

export const toasts = createToasts();
export const invoices = createInvoices();
